import { createAction } from "redux-actions";

export const GALLERY_LIST = "GALLERY_LIST";
export const galleryList = createAction(GALLERY_LIST);

export const GALLERY_SYNC = "GALLERY_SYNC";
export const gallerySync = createAction(GALLERY_SYNC);

export const GALLERY_DETAIL = "GALLERY_DETAIL";
export const galleryDetails = createAction(GALLERY_DETAIL);
